import { BadgeV3, ButtonV2 } from '@cimplico/components';
import { CheckCircleIcon, ExclamationCircleIcon } from '@heroicons/react/20/solid';
import { useNavigate } from 'react-router-dom';
import { useFirmContext } from '../../../providers/FirmProvider';
import { Workpaper } from '../../../types/workpaper';
import OverdueWorkpaperRow from './OverdueWorkpaperRow';

type OverdueWorkpapersProps = {
    overdueWorkpapers: { total: number; topResults: Workpaper[] };
};

function OverdueWorkpapers({ overdueWorkpapers }: OverdueWorkpapersProps): JSX.Element {
    const navigate = useNavigate();
    const { shortId } = useFirmContext();

    return (
        <div className="border rounded-lg border-gray-200 bg-white dark:bg-white/[0.05] dark:border-white/[0.07] p-6 flex flex-col gap-y-4">
            <div className="flex justify-between items-center border-b border-gray-200 dark:border-white/[0.07] pb-2">
                <section className="flex items-center gap-x-2">
                    <BadgeV3 color="gray" size="small" label={overdueWorkpapers.total.toString()} rounded />
                    <h1 className="text-sm font-bold text-gray-800 dark:text-gray-300">Workpapers</h1>
                    <BadgeV3 color="yellow" leftIcon={<ExclamationCircleIcon />} label="Overdue" />
                </section>
                {overdueWorkpapers.total > 0 && (
                    <ButtonV2 type="hollow" label="See all" size="xs" onClick={(): void => navigate(`/${shortId}/workpapers?overdue=true`)} />
                )}
            </div>
            <div className="flex flex-col grow gap-y-2">
                {overdueWorkpapers.total === 0 ? (
                    <div className="flex flex-col gap-y-1 justify-center items-center my-auto">
                        <div className="h-10 w-10 text-green-600 dark:text-green-400">
                            <CheckCircleIcon />
                        </div>
                        <label className="font-bold text-gray-800 dark:text-gray-300 text-lg">No overdue workpapers</label>
                    </div>
                ) : (
                    overdueWorkpapers.topResults.map((workpaper) => {
                        return <OverdueWorkpaperRow key={workpaper.id} workpaper={workpaper} />;
                    })
                )}
            </div>
        </div>
    );
}

export default OverdueWorkpapers;
